import { useId } from "react";

import { actionTooltipProps } from "@/ds";
import type { DominanciaBlocoProps } from "./types-dominancia-bloco";

export function useDominanciaBloco({ titulo }: DominanciaBlocoProps) {
  const infoId = useId();

  return {
    infoId,
    infoSelector: `[id="${infoId}"]`,
    tooltipProps: titulo ? actionTooltipProps(titulo.ajuda, { event: "hover" }) : null,
  };
}
